import { render, staticRenderFns } from "./HealthPolicyForm.vue?vue&type=template&id=429a0d40"
import script from "./HealthPolicyForm.vue?vue&type=script&lang=js"
export * from "./HealthPolicyForm.vue?vue&type=script&lang=js"
import style0 from "./HealthPolicyForm.vue?vue&type=style&index=0&id=429a0d40&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports